import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, FormControl, TextField, Button } from '@material-ui/core';
import _ from 'lodash';
import { getSelectedArea } from '../../Editor/_reducers/theme.reducer';

const useStyles = makeStyles(() => ({
    root: {
        alignItems: 'center',
        backgroundColor: '#fff',
        cursor: 'grab',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flexGrow: 1
    },
    logo: {
        height: 'auto',
        marginTop: 30,
        width: 210
    },
    form: {
        marginTop: 10,
        width: "80%"
    },
    formControl: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ddd',
        borderRadius: 8,
        padding: '12px 14px',
    },
    label: {
        fontSize: 14,
        fontWeight: '600',
        color: '#333',
        margin: '12px 0px 4px 0px',
    },
    placeholderText: {
        fontSize: 15,
        color: '#999'
    },
    button: props =>({
        backgroundColor: props.buttonColor,
        borderRadius: 8,
        color: props.buttonTextColor,
        margin: '15px 0',
        padding: '10px 0',
        width: "100%",
        "&:hover": {
            backgroundColor: props.buttonColor,
        }
    }),
    signUpText: {
        marginTop: 10,
        textAlign: 'center'
    },
    privacyText: {
        color: '#888',
        fontSize: 12,
        margin: '20px 0px 30px 0px'
    },
    privacyTextColor: props => ({
        fontSize: 12,
        color: props.buttonColor
    })
}));


export default function LoginScreen() {
    const selectedArea = useSelector(state => getSelectedArea(state));
    const data = selectedArea.sections.find(s => s.key === 'loginScreenSettings');

    const colors = useSelector(state => state.ThemeReducer.settings.find(s => s.key === 'colors'));
    const classes = useStyles({...data.options, ...colors.options});

    return (
        <div className={classes.root}>
            {data.options.showLogo &&
                <Grid container justify="center">
                    <img
                        alt="logo"
                        className={classes.logo}
                        src={_.get(data, 'options.logo.url', require('../../Editor/_assets/images/image_placeholder_350_350.png'))}
                    />
                </Grid>
            }

            <div className={classes.form}>
                <p className={classes.label}>E-mail *</p>
                <div className={classes.formControl}>
                    <span className={classes.placeholderText}>seu@email.com</span>
                </div>

                <p className={classes.label}>Senha *</p>
                <div className={classes.formControl}>
                    <span className={classes.placeholderText}>Sua senha</span>
                </div>

                <Button className={classes.button}>Entrar</Button>

                <p className={classes.signUpText}>Esqueceu sua senha?</p>

                <p className={classes.signUpText}>Criar uma conta</p>

                <p className={classes.privacyText}>
                    Ao se registrar, você confirma que leu e concorda com a nossa{' '}
                    <span className={classes.privacyTextColor}>Política de Privacidade.</span>
                </p>
            </div>
        </div >
    );
}
